import Translations from "translations/types";

const PARALLEL_SEARCH_KEY = "parallel_search" as const;

const PARALLEL_SEARCH_STEPS = {
  NEW_SEARCH_TAB: "new_search_tab",
  OLD_SEARCH_TAB: "old_search_tab",
} as const;

export const PARALLEL_SEARCH = {
  key: PARALLEL_SEARCH_KEY,
  steps: {
    [PARALLEL_SEARCH_STEPS.NEW_SEARCH_TAB]: {
      intro: (t: Translations) => t.tours.parallelSearch.stepA.intro,
      key: PARALLEL_SEARCH_STEPS.NEW_SEARCH_TAB,
      step: 1,
      title: (t: Translations) => t.tours.parallelSearch.stepA.title,
    },
    [PARALLEL_SEARCH_STEPS.OLD_SEARCH_TAB]: {
      intro: (t: Translations) => t.tours.parallelSearch.stepB.intro,
      key: PARALLEL_SEARCH_STEPS.OLD_SEARCH_TAB,
      step: 2,
      title: (t: Translations) => t.tours.parallelSearch.stepB.title,
    },
  },
} as const;
